import i18n from '@/i18n';

const $t = (text) => {
  return i18n.global.t(text);
};

export const logMetricManage = [
  {
    text: $t('searchLabel.monTarget'), // '모니터링 대상',
    value: 'productName',
    id: 'productName',
    width: 310,
    sortable: true,
    defaultValue: '-',
    order: 1,
    isDefault: true,
    isVisible: true,
    isFixed: true,
    fixed: 'left'
  },
  {
    id: 'productState',
    text: $t('searchLabel.productState'), // 성능수집 OR 상품 상태
    value: 'productState',
    width: 139,
    sortable: true,
    order: 3,
    isVisible: true,
    isFixed: true,
  },
  {
    text: $t('searchLabel.ip'), // 'IP 주소',
    value: 'productIpAddress',
    id: 'productIpAddress',
    width: 148,
    sortable: true,
    order: 99
  },
  {
    text: $t('searchLabel.indi'), // '지표명',
    value: 'metricName',
    id: 'indicator',
    sortable: true,
    order: 3,
    width: 200
  },
  {
    text: $t('searchLabel.patRule'), // '패턴 룰',
    value: 'patternRule',
    id: 'patternRule',
    sortable: true,
    defaultValue: '-',
    order: 4
  },
  {
    text: $t('searchLabel.collectedLog'), // '로그',
    value: 'logName',
    id: 'log',
    sortable: true,
    order: 5,
    width: 140
  },
  {
    text: $t('searchLabel.registrant'), // '등록자',
    value: 'createBy',
    id: 'registrant',
    sortable: true,
    width: 160,
    order: 6
  },
  {
    text: $t('searchLabel.regDate'), // '등록일시',
    value: 'createdDt',
    id: 'regDate',
    sortable: true,
    width: 170,
    order: 3
  },
  {
    id: 'vmState',
    text: $t('searchLabel.vmState'), // vm상태
    value: 'vmState',
    width: 120,
    sortable: true
  },
  {
    id: 'dbVersion',
    text: $t('searchLabel.dbVersion'), // db 버전
    value: 'dbVersion',
    width: 240,
    sortable: true
  },
  {
    id: 'vpcName',
    text: $t('searchLabel.vpcName'), //'LB명',
    value: 'vpcName',
    width: 240,
    sortable: true,
    defaultValue: ''
  },
  {
    id: 'lbSize',
    text: $t('searchLabel.lbSize'), //'LB명',
    value: 'lbSize',
    width: 140,
    sortable: true,
    defaultValue: ''
  },
  {
    id: 'connectedVPC',
    text: $t('searchLabel.connectedVPC'), //'연결VPC',
    value: 'connectedVPC',
    width: 240,
    sortable: true,
    defaultValue: ''
  },
  {
    id: 'appVersion',
    text: $t('searchLabel.appVersion'),
    value: 'appVersion',
    width: 170,
    sortable: true,
    bodyAlign: 'center',
  }
];
